$ = require 'jquery'
Camera = require('app/common/lib/util/camera').Camera
CropPhotoView = require 'app/scripts/views/camera/crop-photo-view'
PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
l = require 'app/scripts/lib/localize'

module.exports = class TakePhotoView extends View
  events:
    'click .js-connect-camera': 'connectCamera'
    'click .js-snap': 'snap'

  willBePopped: ->
    Camera.stop()

  viewTitleKey: 'take a photo'

  render: ->
    data =
      connected: Camera.connected()

    error = Camera.getError()
    if error?
      if error.name == 'PermissionDeniedError'
        data.error = l(['member profile error', 'could not connect to camera'])
      else if error.name?
        data.error = error.name
      else
        data.error = error

    @$el.html(
      templates.fill(
        'take_photo',
        data
      )
    )

    if Camera.connected()
      elVideo = @$('.video')[0]
      if 'srcObject' of elVideo
        elVideo.srcObject = Camera.getStream()
      else
        elVideo.src = Camera.getStream()
      elVideo.play()

    @

  getData: ->
    @connectCamera()

  connectCamera: ->
    Camera.connect (err) =>
      @render()

  snap: ->
    elVideo = @$('.video')[0]
    $canvas = $('<canvas>').attr({ width: 640, height: 480 })
    context = $canvas[0].getContext('2d')
    context.drawImage(elVideo, 0, 0, 640, 480)

    cropView = new CropPhotoView({ @model, @modelCache, savePhoto: @options.savePhoto })
    cropView.setImage($canvas[0].toDataURL('image/png'))

    Camera.stop()

    PopOver.pushView
      view: cropView
      hardToClose: true
